import React, { useState, useEffect } from "react";
import ImageWrapper from "./ImageWrapper";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, A11y } from "swiper";

import "swiper/css/bundle";
import "swiper/css/effect-fade";
import Link from "next/link";

function CmsCollectionItem({ component, page_id = "" }) {
  // console.log(component);

  const mesi = [
    "GENNAIO",
    "FEBBRAIO",
    "MARZO",
    "APRILE",
    "MAGGIO",
    "GIUGNO",
    "LUGLIO",
    "AGOSTO",
    "SETTEMBRE",
    "OTTOBRE",
    "NOVEMBRE",
    "DICEMBRE",
  ];

  const [isClient, setIsClient] = useState(false);

  const item = component.options.items[0];

  useEffect(() => {
    setIsClient(true);
  }, [isClient]);

  return (
    <div id="project">
      <div id={`${component.id ?? ""}`}>
        <h1>{item.title}</h1>
        <div className="dt">
          <p>
            {mesi[new Date(item.date).getMonth()]}{" "}
            {new Date(item.date).getFullYear()}
          </p>
        </div>
        {item.url != "" ? (
          <div className="flex justify-end mb-8">
            <Link href={item.url}>
              <a target={"_blank"} className="externalBtn">
                <span>VAI AL SITO</span>
                <svg viewBox="0 0 24 24">
                  <path d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z" />
                </svg>
              </a>
            </Link>
          </div>
        ) : (
          ""
        )}
        <div className="image">
          {item.cover_img.url != "" && (
            <ImageWrapper
              alt=""
              src={item.cover_img.url}
              blur={item.cover_img.urlp}
              layout="responsive"
              width={1280}
              height={720}
              // priority={true}
              objectFit={"cover"}
            />
          )}
        </div>
        <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
      </div>

      <div class="back">
        <Link href={`/portfolio`}>
          <a target={"_self"} className="backBtn">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z"
              />
            </svg>
            <span>indietro</span>
          </a>
        </Link>
      </div>
    </div>
  );
}

export default CmsCollectionItem;
